import { render, staticRenderFns } from "./UserP2PReviews.vue?vue&type=template&id=1264294a&scoped=true&"
import script from "./UserP2PReviews.vue?vue&type=script&lang=js&"
export * from "./UserP2PReviews.vue?vue&type=script&lang=js&"
import style0 from "./UserP2PReviews.vue?vue&type=style&index=0&id=1264294a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264294a",
  null
  
)

export default component.exports